import { formatCostUsd } from '@src/services/opsService';

/** Shared by the Runs table and the Enrichments screen's "contributing runs" modal -- both render
 * a run row with the same status/outcome/duration/cost/date presentation. */

export function statusBadgeVariant(status: string): 'success' | 'critical' | 'warning' | 'secondary' {
  if (status === 'success') return 'success';
  if (status === 'failed') return 'critical';
  if (status === 'skipped') return 'warning';
  return 'secondary';
}

export function statusLabel(status: string): string {
  if (status === 'success') return 'Success';
  if (status === 'failed') return 'Failed';
  if (status === 'skipped') return 'Skipped';
  return status;
}

export function formatDuration(durationMs?: number): string {
  if (durationMs === undefined) return '—';
  return durationMs >= 1000 ? `${(durationMs / 1000).toFixed(1)}s` : `${durationMs}ms`;
}

export function formatCost(costUsd?: number): string {
  if (costUsd === undefined) return '—';
  if (costUsd === 0) return 'Free';
  return formatCostUsd(costUsd);
}

/** Local calendar date + time for a run's timestamp -- distinct from a relative "2d ago" readout,
 * which collapses anything past a few hours into an unreadable age. */
export function formatRunDate(iso: string): string {
  return new Date(iso).toLocaleString(undefined, {
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

/** Exact UTC instant, for a tooltip -- the local display above is ambiguous across timezones. */
export function formatUtcTooltip(iso: string): string {
  return `${new Date(iso).toISOString().slice(0, 19).replace('T', ' ')} UTC`;
}
